import { render, staticRenderFns } from "./OfferCostSpecifications.vue?vue&type=template&id=0c210943&scoped=true"
import script from "./OfferCostSpecifications.vue?vue&type=script&lang=ts"
export * from "./OfferCostSpecifications.vue?vue&type=script&lang=ts"
import style0 from "./OfferCostSpecifications.vue?vue&type=style&index=0&id=0c210943&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c210943",
  null
  
)

export default component.exports